module.exports = {"370705001":"东关街道","370705002":"大虞街道","370705003":"梨园街道","370705004":"廿里堡街道","370705005":"潍州路街道","370705006":"北苑街道","370705007":"广文街道","370705009":"新城街道","370705010":"清池街道","370705012":"北海路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370705.json
// module id = 1305
// module chunks = 0